var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"place-map"},[_c('div',{staticClass:"place-name"},[_vm._v(_vm._s(_vm.sportEventName))]),_vm._v(" "),_c('div',{attrs:{"id":"map"}})])}
var staticRenderFns = []

export { render, staticRenderFns }